"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_EVENTS = exports.IS_MOBILE = exports.IS_WINDOWS = exports.IS_MAC = exports.IS_IOS = exports.IS_ANDROID = exports.IS_IE = exports.IS_SAFARI = exports.IS_FIREFOX = exports.IS_CHROME = void 0;
const BROWSER_RULES = [
    ['edge', /Edge\/([0-9\._]+)/],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)$/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['android', /Android\s([0-9\.]+)/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
];
const EVENT_RULES = [
    ['beforeinput', el => 'onbeforeinput' in el],
];
const OS_RULES = [
    ['ios', /os ([\.\_\d]+) like mac os/i],
    ['macos', /mac os x/i],
    ['android', /android/i],
    ['firefoxos', /mozilla\/[a-z\.\_\d]+ \((?:mobile)|(?:tablet)/i],
    ['windows', /windows\s*(?:nt)?\s*([\.\_\d]+)/i],
];
let BROWSER;
const EVENTS = {};
let OS;
const { userAgent } = window.navigator;
for (const [name, regexp] of BROWSER_RULES) {
    if (regexp.test(userAgent)) {
        BROWSER = name;
        break;
    }
}
for (const [name, regexp] of OS_RULES) {
    if (regexp.test(userAgent)) {
        OS = name;
        break;
    }
}
const testEl = window.document.createElement('div');
testEl.contentEditable = 'true';
for (const [name, testFn] of EVENT_RULES) {
    EVENTS[name] = testFn(testEl);
}
exports.IS_CHROME = BROWSER === 'chrome';
exports.IS_FIREFOX = BROWSER === 'firefox';
exports.IS_SAFARI = BROWSER === 'safari';
exports.IS_IE = BROWSER === 'ie';
exports.IS_ANDROID = OS === 'android';
exports.IS_IOS = OS === 'ios';
exports.IS_MAC = OS === 'macos';
exports.IS_WINDOWS = OS === 'windows';
exports.IS_MOBILE = exports.IS_ANDROID || exports.IS_IOS;
exports.SUPPORTED_EVENTS = EVENTS;
